import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Grid,
    Button,
    IconButton,
    Divider,
    CircularProgress,

} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { DateTimePicker } from "formik-material-ui-pickers";
import { toast } from "react-toastify";
import { TextField } from "formik-material-ui";
import { usecalibrationInfoAdded } from "../stressEntry/stressEntryQueries";
import { useFetchContext } from "../../../common/FetchContext";



export const UpdateCalibrationDialog = ({
    open,
    onClose,
    asset,
    onUpdated
}: any) => {

    const { mutateAsync: mutate, isLoading } = usecalibrationInfoAdded();

    const { authAxios } = useFetchContext();


    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">
                        Update Calibration Details
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Grid>
            </DialogTitle>

            <Divider />

            <Formik
                enableReinitialize
                initialValues={{
                    calibrationdate: null,
                    text: "",
                    schedule_for_the_calibration: asset?.schedule_for_calibration ?? 0,
                }}
                validationSchema={Yup.object({
                    calibrationdate: Yup.date()
                        .nullable()
                        .required("Calibration date is required"),
                    text: Yup.string(),
                    schedule_for_the_calibration: Yup.number()
                        .typeError("Must be a number")
                        .min(0, "Must be 0 or greater")
                        .integer("Must be a whole number")
                        .required("Schedule days is required"),
                })}
                onSubmit={async (values, { resetForm }) => {
                    try {
                        await mutate({
                            authAxios,
                            last_calibrated_date: values.calibrationdate,
                            notes: values.text,
                            asset_id: asset?.id,
                            requested_schedule_for_calibration: values.schedule_for_the_calibration,
                        });

                        toast.success("Calibration date successfully added.");

                        onUpdated();
                        resetForm();
                        onClose();

                    } catch (error) {
                        toast.error("Failed to update calibration date. Please try again.");
                    }
                }}


            >
                {({ submitForm, touched, errors }) => (
                    <Form>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle1" >
                                        Asset Name: <b>{asset?.asset_name || "N/A"}</b> - Calibration Required for this asset
                                    </Typography>

                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Field
                                        name="calibrationdate"
                                        component={DateTimePicker}
                                        label="Calibration Date"
                                        inputVariant="outlined"
                                        fullWidth
                                        margin="normal"
                                        format="YYYY-MM-DD HH:mm:ss"
                                        maxDate={new Date()}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        name="schedule_for_the_calibration"
                                        type="number"
                                        component={TextField}
                                        label="Schedule for Calibration (Days)"
                                        fullWidth
                                        inputVariant="contained"
                                        margin="normal"
                                        error={
                                            touched.schedule_for_the_calibration &&
                                            Boolean(errors.schedule_for_the_calibration)
                                        }
                                        helperText={
                                            touched.schedule_for_the_calibration
                                                ? errors.schedule_for_the_calibration
                                                : ""
                                        }
                                    />
                                </Grid>


                                <Grid item xs={12}>
                                    <Field
                                        name="text"
                                        component={TextField}
                                        label="Note Text"
                                        placeholder="Add Your Note"
                                        multiline
                                        rows={8}
                                        fullWidth
                                        variant="outlined"
                                        error={touched.text && Boolean(errors.text)}
                                        helperText={touched.text ? errors.text : ""}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={onClose} color="secondary" variant="outlined">
                                Close
                            </Button>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={submitForm}
                                disabled={isLoading}
                                startIcon={
                                    isLoading ? (
                                        <CircularProgress size={20} color="inherit" />
                                    ) : null
                                }
                            >
                                {isLoading ? "Submitting..." : "Submit"}
                            </Button>

                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};
